import React from 'react'
import { Link } from 'react-router-dom'
import CircularProgress from '@material-ui/core/CircularProgress'
import { Button, Container, TextField, Typography } from '@material-ui/core'
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'
import useRegister from '../hooks/useRegister'
import { useAuth } from '../../../providers'

const useStyles = makeStyles((theme) => {
    return {
        container: {
            marginTop: 0,
            paddingTop: theme.spacing(1.5),
            paddingRight: '0rem',
            paddingLeft: '0rem',
            fontFamily: 'Inter',
            width: '100%',
            [theme.breakpoints.up('sm')]: {
                width: '330px',
                // paddingRight: theme.spacing(7),
                // paddingLeft: theme.spacing(7),
            },
        },
        phoneNumberLogin: {
            marginBottom: 20,
            display: 'flex',
            // alignItems: "flex-start",
            alignItems: 'center',
        },
        btn: {
            textTransform: 'none',
            padding: theme.spacing(1),
            fontSize: '1rem',
            fontWeight: 'bold',
        },
        countryCode: {
            backgroundColor: '#F2F5F7',
            // fontSize: 25,
            fontSize: 18,
            padding: theme.spacing(1.25),
            borderRadius: '10px',
            marginRight: '0.5rem',
        },
        phoneNumberField: {
            // fontSize: "1.125rem",
        },
        formTitle: {
            marginBottom: theme.spacing(2),
            fontWeight: 'bold',
        },
        registrationLink: {
            textAlign: 'center',
            marginTop: theme.spacing(2),
            [theme.breakpoints.up('sm')]: {
                marginTop: theme.spacing(11),
                marginBottom: theme.spacing(2),
            },
        },
        link: {
            textDecoration: 'underline',
            fontWeight: '500',
            marginLeft: theme.spacing(1),
            '&:hover': {
                cursor: 'pointer',
            },
        },
    }
})

function PhoneNumberRegistration() {
    const classes = useStyles()
    const { status, error, handleRegister } = useRegister()
    const { phoneNumber, handlePhoneNumber } = useAuth()

    return (
        <Container className={classes.container}>
            <div className={classes.phoneNumberLogin}>
                <Typography className={classes.countryCode} component="span" color="textSecondary">
                    +91
                </Typography>
                <TextField
                    onChange={handlePhoneNumber}
                    variant="outlined"
                    value={phoneNumber}
                    label="Enter your phone number"
                    error={error ? true : false}
                    helperText={error}
                    inputProps={{
                        style: {
                            fontSize: '1rem',
                        },
                        maxLength: 10,
                        inputMode: 'numeric',
                    }}
                    autoFocus
                    required
                    fullWidth
                />
            </div>

            <Button
                className={classes.btn}
                onClick={handleRegister}
                variant="contained"
                color="primary"
                endIcon={status !== 'loading' && <ArrowRightAltIcon />}
                disabled={status === 'loading'}
                fullWidth
            >
                {status === 'loading' ? <CircularProgress size={30} /> : `Send OTP`}
            </Button>
            <Typography className={classes.registrationLink} variant="body2" component="p">
                Already have an account?
                <Link to="/login">
                    <Typography component="span" className={clsx(classes.registrationLink, classes.link)}>
                        Login
                    </Typography>
                </Link>
            </Typography>
        </Container>
    )
}

export default PhoneNumberRegistration
